module.exports = __webpack_public_path__ + "media/images/logo-allcare-cf85bfaf0606f02001638b2ff075d2c7.svg";